import { render, staticRenderFns } from "./searchResult.vue?vue&type=template&id=28614fcc&scoped=true&lang=html&"
import script from "./searchResult.vue?vue&type=script&lang=js&"
export * from "./searchResult.vue?vue&type=script&lang=js&"
import style0 from "./searchResult.vue?vue&type=style&index=0&id=28614fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28614fcc",
  null
  
)

export default component.exports